import moment from 'moment';

export function getCutoffCoverageDescription(startDate, endDate) {
    const start = moment(startDate);
    const end = moment(endDate);

    const sameYear = start.year() === end.year();
    const sameMonth = start.month() === end.month() && sameYear;

    if (sameMonth) {
        // Aug 1–15, 2025
        return `${start.format('MMM D')} - ${end.format('D, YYYY')}`;
    }

    if (sameYear) {
        // Aug 25 – Sep 10, 2025
        return `${start.format('MMM D')} - ${end.format('MMM D, YYYY')}`;
    }

    // Dec 26, 2025 – Jan 10, 2026
    return `${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}`;
}
